<template>
  <div class="videoKan inner">
    <!-- 新媒看新区 -->
    <div class="top">
      <!-- 轮播 -->
      <div class="vlunbo">
        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item,index) in xinqulist.lunbolist"
              :key="index"
              @click="toPlay(item.video_id)"
            >
              <div class="pic">
                <img :src="adddom(item.thumb_image?item.thumb_image:'')" alt="pic" />
                <span class="title">{{item.title}}</span>
              </div>
            </div>
          </div>
          <!-- 导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
      <!-- 视频列表 -->
      <div class="videoList">
        <div
          class="videoItem"
          v-for="(item,index) in xinqulist.recomlist"
          :key="index"
          @click="toPlay(item.video_id)"
        >
          <img :src="adddom(item.thumb_image?item.thumb_image:'')" alt="pic" />
          <span class="title">{{item.title}}</span>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="left">
        <!-- 时下热门 -->
        <div class="sxHot">
          <!-- 标题 -->
          <el-tabs v-model="activeSx">
            <el-tab-pane label="时下热门" name="sx"></el-tab-pane>
          </el-tabs>
          <div class="sxList">
            <div
              class="sxItem"
              v-for="(item,index) in xinqulist.hotlist"
              :key="index"
              @click="toPlay(item.video_id)"
            >
              <div class="pic">
                <img :src="adddom(item.thumb_image?item.thumb_image:'')" alt="pic" />
                <span class="time">{{item.video_length}}</span>
              </div>
              <div class="desc">
                <div class="name">
                  <span>{{item.title}}</span>
                </div>
                <div class="bot">
                  <div class="kan">
                    <img src="/statics/image/index/see.png" alt />
                    <span>{{item.count}}</span>
                  </div>
                  <!-- <div class="yan">
                    <img src="/statics/image/index/mes.png" alt />
                    <span>0</span>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 最新视频 -->
        <div class="zxNews">
          <div class="more" @click="tomore">
            <span>更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <!-- 标题 -->
          <el-tabs v-model="activeZx">
            <el-tab-pane label="最新视频" name="zx"></el-tab-pane>
          </el-tabs>
          <div class="sxList">
            <div
              class="sxItem"
              v-for="(item,index) in xinqulist.newlist"
              :key="index"
              @click="toPlay(item.video_id)"
            >
              <div class="pic">
                <img :src="adddom(item.thumb_image?item.thumb_image:'')" alt="pic" />
                <span class="time">{{item.video_length}}</span>
              </div>
              <div class="desc">
                <div class="name">
                  <span>{{item.title}}</span>
                </div>
                <div class="bot">
                  <div class="kan">
                    <img src="/statics/image/index/see.png" alt />
                    <span>{{item.count}}</span>
                  </div>
                  <!-- <div class="yan">
                    <img src="/statics/image/index/mes.png" alt />
                    <span>0</span>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 更多精彩 -->
      <div class="right">
        <h3>更多精彩</h3>
        <div class="top_pic" @click="toPlay(xinqulist.otherlist[0].video_id)">
          <img :src="adddom(xinqulist.otherlist[0]&&xinqulist.otherlist[0].thumb_image?xinqulist.otherlist[0].thumb_image:'')" alt="pic" />
        </div>
        <div
          class="jcItem"
          v-for="(item,index) in xinqulist.otherlist.slice(1)"
          :key="index"
          @click="toPlay(item.video_id)"
        >
          <div class="pic">
            <img :src="adddom(item.thumb_image?item.thumb_image:'')" alt="pic" />
          </div>
          <div class="con">
            <span class="biao slh">{{item.title}}</span>
            <span class="shi">{{item.publish_at}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeSx: "sx",
      activeZx: "zx",
      xinqulist: {
        lunbolist:[],
        recomlist:[],
        hotlist:[],
        newlist:[],
        otherlist:[]
      }
    };
  },
  created() {
    this.getVideo();
    function mobileskip() {
      var mobileAgent = new Array(
        "iphone",
        "ipod",
        "ipad",
        "android",
        "mobile",
        "blackberry",
        "webos",
        "incognito",
        "webmate",
        "bada",
        "nokia",
        "lg",
        "ucweb",
        "skyfire"
      );
      var browser = navigator.userAgent.toLowerCase();
      var isMobile = false; //记录是否移动端
      for (var i = 0; i < mobileAgent.length; i++) {
        if (browser.indexOf(mobileAgent[i]) != -1) {
          isMobile = true;
          break;
        }
      }
      return isMobile;
    }
    if (mobileskip()) {
      // console.log("222");
      // 移动端
      this.$router.push({
        path: "/videoKanPhone",
      });
    }
  },
  methods: {
    // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    getVideo() {
      var that = this;
      that.$api.index.xinqulist({}).then(function(res) {
        if (res.code == 200) {
          that.xinqulist = res.result;
        }
      });
    },
    //   点击最新视频更多
    tomore() {
      // console.log("111");
      this.$router.push({
        path: "/video",
        query: {
          cate_id: 1
        }
      });
    },
    toPlay(id) {
      this.$router.push({
        path: "/videoPlay",
        query: {
          id: id
        }
      });
    }
  },
  mounted() {
  },
  updated() {
    setTimeout(function(){
      var mySwiper = new Swiper(".mySwiper", {
        loop: true, // 循环模式选项
        //   autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: false
        //   },
        // 前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
    },100)
  }
};
</script>

<style lang="scss" scoped>
.swiper { 
  width: 100%;
  height: 1.42rem;
  position: relative;
}
.swiper-slide{
  width: 2.3rem!important;
}
.swiper .pic {
  width: 2.3rem;
  // width: 100%;
  height: 1.42rem;
}
.swiper .pic img {
 width: 100%;
  height: 100%;
}
.swiper-button-next,
.swiper-button-prev {
  //   color: rgba(250, 250, 250, 0.9);
  //   background-color: rgba(0, 0, 0, 0.5);
  width: 0.17rem;
  height: 0.17rem;
  background-color: #5b6b7c;
  color: #fff;
}
.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  font-size: 0.1rem;
}
.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
  font-size: 0.1rem;
}
.swiper-button-next {
  right: 0;
  border-radius: 0.1rem 0 0 0.1rem;
}

.swiper-button-prev {
  left: 0;
  border-radius: 0 0.1rem 0.1rem 0;
}
</style>